import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { MpCommonService } from "../../../services/api/mp-common.service";
import { MpCommonActions } from "../../actions/mp-common.actions";
import { FailState } from "../../models/fail-state";
import { OnOrbitCountryState } from "../../models/mp-common/on-orbit-country.state";
import { AppState } from "../../reducers";
import { MpCommonSelectors } from "../../selectors/mp-common.selectors";

@Injectable()
export class OnOrbitCountryEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.onOrbitCountry.get),
			withLatestFrom(this.store.select(MpCommonSelectors.onOrbitCountry)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(MpCommonActions.onOrbitCountry.success(state))
					: of(MpCommonActions.onOrbitCountry.api())
			)
		)
	);

	api = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.onOrbitCountry.api),
			switchMap(() =>
				this.mpCommonService.onOrbitCountries().pipe(
					map((onOrbitCountry) =>
						MpCommonActions.onOrbitCountry.success({
							onOrbitCountry: _.sortBy(onOrbitCountry, "name"),
							loading: false
						})
					),
					catchError((error) =>
						of(MpCommonActions.onOrbitCountry.fail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private mpCommonService: MpCommonService
	) {}

	private canUseStoreValue(state: OnOrbitCountryState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
